import { delay, HttpResponse } from "msw";

export const getTerms = async () => {
  await delay("real");
  return HttpResponse.json({
    accepted: true,
    terms: "string",
  });
};
